import React from 'react'

import { SvgIcon } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export const path = `
  M13.431 20.865c-1.667 0-3.334-.026-5.01.012-.885.02-1.29-.247-1.28-1.045.024-2.29-.036-4.58.018-6.87.011-1.423.67-2.786
  1.833-3.789 1.163-1.003 2.735-1.565 4.373-1.564 3.459-.026 6.212 2.183 6.346 5.21.102 2.374.042 4.754.046 7.132 0 .635
  -.359.933-1.124.923-1.733-.024-3.466-.007-5.202-.009zM7.193 4.46C6.733 2.091 8.596.502 11.163.953c2.42.422 4.825.845
  7.23 1.253.827.139 1.332.555 1.402 1.266.046.497-.036.995-.871.991-3.892-.012-7.785-.005-11.73-.005zM15.587 7.052h-4.29
  V5.19h4.29v1.86zM6.58 8.161c.225-1.036.43-1.984.645-2.99h1.642C8.63 6.53 7.797 7.429 6.58 8.162zM6.27 4.264c-1.495.07
  -1.535.042-1.453-1.122l1.453-.25v1.372zM1.467 1.564l1.839.796c-.767.469-1.713.104-1.84-.796zM1.711 4.09l-.902-.462c.345
  -.087.694-.249 1.036-.238.343.01.635.2.952.31l-1.086.39zM1.176 5.28l1.85-.748.228.41-1.83.812-.248-.474z
`

const Icon = props => {
  const { palette } = useTheme()
  const fill = props.color || props.htmlColor ? 'currentColor' : palette.ipm?.peach ?? 'salmon'

  return (
    <SvgIcon {...props}>
      <defs>
        <clipPath id="yi34lb5wza">
          <path fill="#fff" transform="translate(.81 .877)" d="M0 0h19v20H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#yi34lb5wza)">
        <path d={path} fill={fill} />
      </g>
    </SvgIcon>
  )
}

export default Icon
